import { useQuery } from '@tanstack/react-query'

import type { ICustomer } from '@albacross/types'

import { get, type Paginated } from 'utils/http'
import { getPaginatedTableQuery } from 'utils/url'

const getCustomers = (meta: any) =>
  get<Paginated<ICustomer>>('/management/customers', { query: getPaginatedTableQuery(meta) })

export const useCustomers = (meta: any) =>
  useQuery({
    queryKey: ['customers', meta],
    queryFn: () => getCustomers(meta),
  })
